// Where to go after logging in. Only paths on this site are allowed, so a crafted login link can't send
// people elsewhere ("//evil.com" and "/\evil.com" are other hosts to a browser).
const safeRedirectPath = (value: unknown): string | null => {
    if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) return null
    if (value.startsWith('/login') || value.startsWith('/api/')) return null
    return value
}

const loginPathFor = (redirect: string) => {
    const path = safeRedirectPath(redirect)
    return path && path !== '/' ? `/login?redirect=${ encodeURIComponent(path) }` : '/login'
}

export { safeRedirectPath, loginPathFor }
